import React from 'react';
import PropTypes from 'prop-types';
import { Document, Page, View, Text } from '@react-pdf/renderer';

import Header from '../Header';
import { styles } from '../styles';
import { convertToReal, convertFormattedMoneyAndNegativeMoneyToNumber } from '../../../../helpers/converters';

const col3 = { width: `${100 / 3}%` };

const Table = ({ data }) => {
  const convertToDate = str => `${str.substring(6, 8)}/${str.substring(4, 6)}/${str.substring(0, 4)}`;

  if(data?.length == 0) {
    return(
      <View style={styles.tableFinancial}>
        <View style={[styles.tableColFinancial, { width: '100%' }]}>
          <Text style={[styles.tableCellFinancial, { textAlign: 'center' }]}>
            Não há registros
          </Text>
        </View>
      </View>
    );
  }

  return(
    <View style={styles.tableFinancial}>
      <View style={styles.tableRowFinancial}>
        <View style={[styles.tableColHeaderFinancial, col3]}>
          <Text style={styles.tableCellHeaderFinancial}>Data</Text>
        </View>
        <View style={[styles.tableColHeaderFinancial, col3]}>
          <Text style={styles.tableCellHeaderFinancial}>Quantidade</Text>
        </View>
        <View style={[styles.tableColHeaderFinancial, col3]}>
          <Text style={styles.tableCellHeaderFinancial}>Total</Text>
        </View>
      </View>
      {data?.map(usageResume => (
        <View style={styles.tableRowFinancial}>
          <View style={[styles.tableColFinancial, col3]}>
            <Text style={styles.tableCellFinancial}>
              {convertToDate(usageResume?.days)}
            </Text>
          </View>
          <View style={[styles.tableColFinancial, col3]}>
            <Text style={styles.tableCellFinancial}>
              {usageResume?.total}
            </Text>
          </View>
          <View style={[styles.tableColFinancial, col3]}>
            <Text style={styles.tableCellFinancial}>
              {convertToReal(convertFormattedMoneyAndNegativeMoneyToNumber(usageResume?.amount) * usageResume?.total)}
            </Text>
          </View>
        </View>
      ))}
    </View>
  );
}

const UsageResume = ({
  exportData,
  dateRange,
  fileName,
  establishmentName
}) => {
  return(
    <Document>
      <Page style={styles.body}>
        <Header
          fileName={fileName}
          dateRange={dateRange}
          establishmentName={establishmentName}
        />
        <View style={{ marginTop: 10 }}>
          <Text style={[styles.financialResumeTitle, { marginBottom: 10 }]}>
            Resumo de Uso
          </Text>
          <Table data={exportData} />
        </View>
      </Page>
    </Document>
  );
}

UsageResume.propTypes = {
  exportData: PropTypes.arrayOf(PropTypes.shape.isRequired).isRequired,
  dateRange: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  fileName: PropTypes.string.isRequired,
  establishmentName: PropTypes.string.isRequired
};

Table.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape.isRequired).isRequired
};

export default UsageResume;